<template>
  <span>
    <i class="fas fa-calendar r4"></i>
    <code v-if="!gran">
      {{ new Date(unixtime).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }) }}
    </code>
    <code v-else-if="gran === 'nice'">
      {{ new Date(unixtime).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'long', minute: '2-digit', hour12: false }) }}
    </code>
    <code v-else>
      {{ new Date(unixtime).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }} {{ new Date(unixtime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) }} 
    </code>
  </span>
</template>

<script>
export default {
  name: "itime",
  props: { "timestamp": { type: [Number, Date, String, Object] }, "gran": { type: String } },
  computed: {
    unixtime() {
      if (typeof this.timestamp === 'number') {
        return this.timestamp;
      } else if (typeof this.timestamp === 'string') {
        const num = parseInt(this.timestamp);
        if (!isNaN(num)) {
          return num;
        }
        return +new Date(this.timestamp);
      } else {
        return +new Date(this.timestamp);
      }
    }
  }
};
</script>